import { render } from "./QuizDragDrop.vue?vue&type=template&id=3f225239"
import script from "./QuizDragDrop.vue?vue&type=script&lang=js"
export * from "./QuizDragDrop.vue?vue&type=script&lang=js"
script.render = render

export default script